import { useEffect } from 'react';

import { clientConfig } from '@/config/clientConfig';
import { useNotices } from '@/features/notices/useNotices';
import { ProfileType } from '@/shared/api';
import { KeyPair } from '@/shared/lib/secure-json/core/crypto-core/types';
import { useCollectionsStatusStore } from '@/shared/lib/sj-orm/stores/collectionsStatus.store';
import { ErrorInit } from '@/shared/lib/sj-orm/synchronizer/components/ErrorInit';
import { useKeyPairStore } from '@/shared/store/decrypted-keypair.store';
import { useProfileStore } from '@/shared/store/profile.store';
import { log } from '@/shared/utils/log';

import { useCollectionsInit } from './useCollectionsInit';

export const useCollectionsInitializer = () => {
  const notices = useNotices();

  const keyPair = useKeyPairStore((s) => s.keyPair);
  const profileStore = useProfileStore();
  const colStatusStore = useCollectionsStatusStore();
  const colInit = useCollectionsInit();

  const fetchCollections = async (pair: KeyPair) => {
    log.trace('[CollectionsContainer] fetchCollections');
    const res = await colInit.initialFetchCollections(pair);

    if (res.error) {
      const list = res.collections ?? [];
      const items = list.slice(0, 3);
      const more = list.slice(3);

      if (more.length) {
        items.push(`+${more.length} more`);
      }

      notices.error(<ErrorInit items={items} />, { delay: 5 });
    }
  };

  //#region WebApp init
  useEffect(() => {
    if (clientConfig.isExported || !keyPair) return;

    if (colStatusStore.isReadyForInit && colStatusStore.status === 'none') {
      fetchCollections(keyPair);
    }
  }, [colInit, colStatusStore.status, colStatusStore.isReadyForInit, keyPair]);

  //#region Myhub Init
  useEffect(() => {
    if (!clientConfig.isExported || !keyPair) return;

    if (colStatusStore.isReadyForInit && colStatusStore.status === 'none') {
      fetchCollections(keyPair);
    }
  }, [colInit, colStatusStore.status, colStatusStore.isReadyForInit, keyPair]);

  useEffect(() => {
    if (!clientConfig.isExported || !keyPair) return;

    if (!colStatusStore.isReadyForInit && colStatusStore.status === 'none') {
      profileStore.setProfileType(ProfileType.MAIN_USER);
      colStatusStore.setReadyForInit();
    }
  }, [colStatusStore.isReadyForInit, colStatusStore.status, keyPair]);
};
